// extracted by mini-css-extract-plugin
export default {"badge_card_container":"BadgeCard_badge_card_container__NG4cW","badge_card_badge":"BadgeCard_badge_card_badge__qDpZB"};